import {
  aCreateFirstSeenRule,
  mockCreateFirstSeenRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { ruleBuilderQuery_firstSeen } from '../queries/RuleBuilderQueryOperation.mocks';

export const createFirstSeenRuleResponse = {
  __typename: 'Mutation',
  createFirstSeenRule: aCreateFirstSeenRule({
    data: { ...ruleBuilderQuery_firstSeen.rule },
  }),
};

export const handlers = [
  mockCreateFirstSeenRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-expect-error windowSizeInMilliseconds is aliased which causes issues with typing since MSW doesn't handle this case
        data: createFirstSeenRuleResponse,
      });
    }
  ),
];
